import type { EffectDef, EffectId } from './types';

export const EFFECTS: readonly EffectDef[] = [
  { id: 'normal', label: 'Normal', category: 'filter', requiresFace: false },
  { id: 'sepia', label: 'Sepia', category: 'filter', requiresFace: false },
  { id: 'bw', label: 'Black & White', category: 'filter', requiresFace: false },
  { id: 'thermal', label: 'Thermal', category: 'filter', requiresFace: false },
  { id: 'xray', label: 'X-Ray', category: 'filter', requiresFace: false },
  { id: 'comic', label: 'Comic Book', category: 'filter', requiresFace: false },
  { id: 'pencil', label: 'Color Pencil', category: 'filter', requiresFace: false },
  { id: 'glow', label: 'Glow', category: 'filter', requiresFace: false },
  { id: 'plastic', label: 'Plastic Camera', category: 'filter', requiresFace: false },
  // Distortions look better with face tracking (centered on the face) but the
  // shader falls back to screen-center, so they're usable without it.
  { id: 'bugout', label: 'Bug Out', category: 'distortion', requiresFace: false },
  { id: 'twirl', label: 'Twirl', category: 'distortion', requiresFace: false },
  { id: 'squeeze', label: 'Squeeze', category: 'distortion', requiresFace: false },
  { id: 'mirror', label: 'Mirror', category: 'distortion', requiresFace: false },
  // Face-tracked overlays.
  { id: 'lovestruck', label: 'Lovestruck', category: 'overlay', requiresFace: true },
  { id: 'dizzy', label: 'Dizzy', category: 'overlay', requiresFace: true },
  { id: 'sunglasses', label: 'Sunglasses', category: 'overlay', requiresFace: true },
  { id: 'tiara', label: 'Tiara', category: 'overlay', requiresFace: true },
  { id: 'halo', label: 'Halo', category: 'overlay', requiresFace: true },
  { id: 'puppy', label: 'Puppy', category: 'overlay', requiresFace: true },
  { id: 'cat', label: 'Cat', category: 'overlay', requiresFace: true },
  { id: 'lashes', label: 'Lashes', category: 'overlay', requiresFace: true },
  // Beauty filters that distort or smooth in shader.
  { id: 'eyeBig', label: 'Big Eyes', category: 'beauty', requiresFace: true },
  { id: 'smooth', label: 'Skin Smooth', category: 'beauty', requiresFace: false },
] as const;

export const EFFECT_INDEX: Record<EffectId, number> = EFFECTS.reduce(
  (acc, def, idx) => {
    acc[def.id] = idx;
    return acc;
  },
  {} as Record<EffectId, number>,
);

export function getEffect(id: EffectId): EffectDef {
  const def = EFFECTS.find((e) => e.id === id);
  if (!def) {
    throw new Error(`Unknown effect ${id}`);
  }
  return def;
}

export function effectsByCategory() {
  const out: Record<'filter' | 'distortion' | 'overlay' | 'beauty', EffectDef[]> = {
    filter: [],
    distortion: [],
    overlay: [],
    beauty: [],
  };
  for (const e of EFFECTS) out[e.category].push(e);
  return out;
}
